<template>
  <div class="" v-if="registeredAddresses.length > 0">
    <h2>メールアドレスの発行申請を承りました</h2>

    <p>
      「<b>{{ originalAddress }}</b>」に転送を行うメールアドレスを {{ registeredAddresses.length }} 件発行致しました。お申込の際は以下をご利用下さい。<br>
      （※同様の内容を上記メールアドレス宛にも送付致しておりますので、ご確認下さい。）
    </p>

    <ul class="registered-addresses">
      <li v-for="registered in registeredAddresses">
        {{ registered.id }}@fwd.evecre.com
      </li>
    </ul>

    <p>
      尚、有効期限は「<b>{{ expiresOn.format("YYYY年MM月DD日 HH時mm分") }}</b>」までとなっておりますので、ご了承下さい。
    </p>

    <h3>発行件数が希望件数に満たない場合</h3>

    <p>
      転送メールアドレスは1つの転送先あたり、最大で5件までとさせて頂いております。既に登録があった場合、希望する件数に満たない可能性がございます。
    </p>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data: () => {
      const registeredAddressesAsJson = sessionStorage.getItem('registeredAddresses')
      const registeredAddresses = registeredAddressesAsJson !== null ? JSON.parse(registeredAddressesAsJson) : []

      return {
        originalAddress: registeredAddresses.length > 0 ? registeredAddresses[0].original_address : '',
        expiresOn: moment.unix(registeredAddresses.length > 0 ? registeredAddresses[0].expires_on : 0),
        registeredAddresses: registeredAddresses
      }
    },
    mounted () {
      if (this.registeredAddresses.length === 0) {
        this.$router.replace({ name: 'form' })
      }
    }
  }
</script>

<style scoped lang="scss">
  .registered-addresses {
    margin: 2rem 0;
  }
</style>



// WEBPACK FOOTER //
// Complete.vue?024a12b0